module.exports = __webpack_public_path__ + "static/media/CELL_3.e88768c4.png";